const ITEMS = [
  "Tell us what you need",
  "We\u2019ll do the market work",
  "You stay in control",
  "Recurring Supply",
  "Multi-Location Procurement",
  "Jet A-1",
  "Marine Fuels",
  "Managed Procurement",
];

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-white/5 py-10 md:py-14 overflow-hidden mask-fade-x select-none"
      aria-hidden="true"
    >
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center">
            {ITEMS.map((t, i) => (
              <span key={i} className="flex items-center">
                <span className="font-outfit text-4xl md:text-6xl font-extralight tracking-tight text-stroke px-8 md:px-12">
                  {t}
                </span>
                <span className="w-2 h-2 rotate-45 bg-gold/60 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
